export const inboundInvoiceStatus = {
  authorized: { color: 'green', label: 'Autorizada' },
  denied: { color: 'red', label: 'Denegada' },
  canceled: { color: 'gray', label: 'Cancelada' }
};

export const inboundManifestation = {
  none: { label: 'Não manifestada', description: 'Não manifestada' },
  acknowledged: {
    color: 'blue',
    label: 'Ciência',
    description: 'Ciência da operação'
  },
  confirmed: {
    color: 'green',
    label: 'Confirmada',
    description: 'Confirmação da operação'
  },
  unknown: {
    color: 'orange',
    label: 'Desconhecida',
    description: 'Desconhecimento da operação'
  },
  notPerformed: {
    color: 'orange',
    label: 'Não realizada',
    description: 'Operação não realizada'
  },
  rejected: { color: 'red', label: 'Rejeitada', description: 'Rejeitada' }
};

export const inboundStatusByModel = {
  productInvoice: ['authorized', 'denied', 'canceled'],
  serviceInvoice: ['authorized', 'canceled']
};

export const inboundManifestationByModel = {
  productInvoice: [
    'none',
    'acknowledged',
    'confirmed',
    'unknown',
    'notPerformed'
  ],
  serviceInvoice: ['none', 'confirmed', 'rejected']
};

export const serviceRejectionReasons = [
  { value: 1, label: 'Nota fiscal duplicada' },
  { value: 2, label: 'Nota já emitida pelo tomador' },
  { value: 3, label: 'Serviço sem fato gerador' },
  { value: 4, label: 'Erro na responsabilidade tributária' },
  { value: 5, label: 'Erro no valor, no serviço prestado ou na data' },
  { value: 9, label: 'Outros motivos' }
];
